import * as CONSTANTS from './constants'

export const startLoading = (label) => {
  return async (dispatch) => {
    dispatch({ type: CONSTANTS.START_LOADING, payload: { label } })
  }
}

export const endLoading = () => {
  return async (dispatch) => {
    dispatch({ type: CONSTANTS.END_LOADING })
  }
}
